export enum PermissionsMediaPagesEnum {
  MediaServer = 1
}
